import { start } from './start';
import config from './config';

start(config);
